module.exports=function anonymous(obj,microTemplate
) {
var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push('<div id="js-SettingsTwoStepReactRoot"></div> ');}return p.join('');
}